import React from 'react';

const Data = [
    {
        image: "/images/brand/logo-1.png"
    },
    {
        image: "/images/brand/iaslogos-1.png"
    }
]


const BrandItem = () => {
    return (
        <>
            {Data.map((data, index) => (
                <div className="col-lg-3 col-6" key={index}>
                    <div className="brand-grid">
                        <img src={ data.image} alt="Brand" />
                    </div>
                </div>
            ))}
        </>
    )
}

export default BrandItem;